import { render, staticRenderFns } from "./SmartPillboxList.vue?vue&type=template&id=277c8955&scoped=true"
import script from "./SmartPillboxList.vue?vue&type=script&lang=js"
export * from "./SmartPillboxList.vue?vue&type=script&lang=js"
import style0 from "./SmartPillboxList.vue?vue&type=style&index=0&id=277c8955&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277c8955",
  null
  
)

export default component.exports